import type { NonconformingDisposition, NonconformingOutputStatus } from './types';

export const STATUS_LABEL: Record<NonconformingOutputStatus, string> = {
  identificado: 'Identificado',
  en_disposicion: 'En disposición',
  cerrado: 'Cerrado',
};

export const DISPOSITION_LABEL: Record<NonconformingDisposition, string> = {
  reproceso: 'Reproceso',
  concesion: 'Concesión',
  rechazo: 'Rechazo',
  reclasificacion: 'Reclasificación',
};

export const NEXT_STATUS: Partial<Record<NonconformingOutputStatus, NonconformingOutputStatus>> = {
  identificado: 'en_disposicion',
  en_disposicion: 'cerrado',
};

export function statusBadgeClass(status: NonconformingOutputStatus): string {
  switch (status) {
    case 'cerrado':
      return 'bg-emerald-100 text-emerald-800';
    case 'en_disposicion':
      return 'bg-amber-100 text-amber-800';
    default:
      return 'bg-red-100 text-red-800';
  }
}
